import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const AlertContainer = styled.div`
  svg {
    width: 50px;
  }
`
